import TermsOfUseModal from "./terms-of-use-modal";

export default TermsOfUseModal;
